import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Fab from '@material-ui/core/Fab';
import { isTablet } from 'react-device-detect';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const styles = () => ({
  fabRoot: {
    position: 'fixed',
    top: '95px',
    left: '20px',
    zIndex: 5,
  },
  fabRootTablet: {
    position: 'fixed',
    top: '100px',
    right: '20px',
    zIndex: 5,
  },
  listIcon: {},
});

class UndoFocusLayer extends Component {
  render() {
    const { classes } = this.props;

    let rootClass = classes.fabRoot;
    if (isTablet) {
      rootClass = classes.fabRootTablet;
    }

    return (
      <>
        <div className={rootClass}>
          <div>
            <Fab
              variant="extended"
              color="secondary"
              aria-label="add"
              className={classes.listIcon}
              onClick={() => {
                this.props.onBackButtonHandler();
              }}
            >
              <ArrowBackIcon />
            </Fab>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(UndoFocusLayer);
